import React, { memo } from 'react'
import { CloudUploadOutlined } from '@ant-design/icons'
import { Divider } from 'antd'
import PropTypes from 'prop-types'
import { blue } from '../../color'

const DraggerUploadButton = propsDraggerUploadButton => {
  const {
    acceptFileLabel = 'JPG, PNG, PDF, XLS, DOC, PPT',
    maxFileSizeLabel = '100MB',
  } = propsDraggerUploadButton

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ marginBottom: 8 }}>
        <CloudUploadOutlined
          style={{
            fontSize: 40,
            color: blue,
          }}
        />
      </div>
      <p
        style={{
          margin: '0 0 6px',
          fontSize: 14.5,
          fontWeight: 600,
          color: '#1e293b',
        }}>
        Kéo thả file, hình ảnh hoặc{' '}
        <span
          style={{
            color: blue,
            textDecoration: 'underline',
            cursor: 'pointer',
          }}>
          Tải lên
        </span>
      </p>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          flexWrap: 'wrap',
        }}>
        <span style={{ fontSize: 12.5, color: '#64748b' }}>
          Hỗ trợ: {acceptFileLabel}
        </span>
        <Divider
          type="vertical"
          style={{
            margin: 0,
            height: 14,
            borderColor: '#cbd5e1',
          }}
        />
        <span style={{ fontSize: 12.5, color: '#64748b' }}>
          Dung lượng tối đa: {maxFileSizeLabel}
        </span>
      </div>
    </div>
  )
}

DraggerUploadButton.propTypes = {
  acceptFileLabel: PropTypes.string,
  maxFileSizeLabel: PropTypes.string,
}

export default memo(DraggerUploadButton)
